import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { useSettings } from '../../contexts/settingsContext';

interface Props {
  required?: boolean;
  onChange?: (value: Date) => void;
  dropdownLayout?: boolean;
  value?: Date;
}

const DatePicker = ({ required, onChange, dropdownLayout = false, value }: Props) => {
  const { cornerRadius, interactionColor } = useSettings();

  const handleSelect = (date?: Date) => {
    if (date && onChange) {
      onChange(date);
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <DayPicker
      mode="single"
      selected={value}
      onSelect={handleSelect}
      required={required}
      fromYear={dropdownLayout ? currentYear - 15 : undefined}
      toYear={dropdownLayout ? currentYear : undefined}
      captionLayout={dropdownLayout ? 'dropdown-buttons' : 'buttons'}
      styles={{
        month: {
          borderRadius: cornerRadius,
        },
      }}
      modifiersStyles={{
        selected: {
          backgroundColor: interactionColor,
        },
      }}
    />
  );
};

export default DatePicker;
